import React from 'react'
import styled from 'styled-components'
import { border, color, fontSize, space, textAlign, width } from 'styled-system'

const STYLE_PROPS = {
  xxs: {
    maxWidth: '1px'
  },
  xs: {
    width: '30px'
  },
  sm: {
    maxWidth: '100px'
  },
  md: {},
  lg: {
    maxWidth: '250px'
  }
}

const Wrapper = styled.div.attrs(props => {
  return {
    overflow: 'auto',
    ...props
  }
})`
  flex: ${({ flex }) => (flex ? flex : undefined)};
  margin-left: -15px;
  overflow: ${({ overflow }) => overflow};
  padding-left: 15px;
  position: relative;
  table {
    opacity: ${({ disabled }) => (disabled ? '0.5' : '1')};
  }

  tr {
    pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  }
`

const StyledTable = styled.table`
  max-width: 100%;
  overflow-x: auto;
  text-align: left;
  width: 100%;

  ${({ bleed }) =>
    !bleed
      ? `
  td:first-of-type, th:first-of-type {padding-left: 0;}
  td:last-of-type, th:last-of-type {padding-right: 0;}
`
      : ''}
`

const Table = ({ header, overflow, disabled, wrapperProps, bleed = true, ...props }) => (
  <Wrapper overflow={overflow} disabled={disabled} {...wrapperProps}>
    {header}
    <StyledTable bleed={bleed} {...props} />
  </Wrapper>
)

export const Thead = styled.thead``

export const Tr = styled.tr`
  ${({ selectable }) => !selectable || `cursor: pointer;`};
`

export const StyledTd = styled.td.attrs(props => {
  return {
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    borderTopWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'light-dark(var(--brand-grey-100), var(--brand-grey-500))',
    py: 2,
    px: 3,
    verticalAlign: 'middle',
    ...props
  }
})`
  vertical-align: ${({ verticalAlign }) => verticalAlign};
  white-space: wrap;
  text-overflow: ellipsis;
  max-width: ${({ maxWidth }) => maxWidth};
  opacity: ${({ disabled }) => (disabled ? '.5' : '1')};

  ${color}
  ${border}
  ${fontSize}
  ${space}
  ${textAlign}
  ${width}
`

export const Td = props => {
  return <StyledTd {...STYLE_PROPS[props.level]} {...props} />
}

const StyledTh = styled(StyledTd).attrs(props => {
  return {
    as: 'th',
    borderTopWidth: 0,
    color: 'light-dark(var(--brand-grey-400), var(--brand-grey-100))',
    fontSize: '14px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    ...props
  }
})`
  text-transform: ${({ textTransform }) => textTransform};
  overflow: visible;
  color: light-dark(var(--brand-grey-400), var(--brand-grey-100));
`

export const Th = props => {
  return (
    <StyledTh
      as="th"
      fontSize="14px"
      fontWeight="bold"
      textTransform="uppercase"
      {...STYLE_PROPS[props.level]}
      {...props}
    />
  )
}

export const Tbody = styled.tbody`
  :nth-child(odd) tr {
    background: ${({ stripedColor, theme }) =>
      stripedColor ? theme.colors[stripedColor] : 'light-dark(white, var(--brand-grey-700))'};
  }

  ${border}
  ${color}
`

export default Table
